import { render, staticRenderFns } from "./DirectSignupForm.vue?vue&type=template&id=2b2740ed&scoped=true"
import script from "./DirectSignupForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./DirectSignupForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DirectSignupForm.vue?vue&type=style&index=0&id=2b2740ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2740ed",
  null
  
)

export default component.exports